import header from './header.json';

const en = {
  ...header,
};

export { en };
